import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
  } from '@angular/core';
  import { SelectItem } from 'src/app/modules/shared/components/custom-select/select-item';
  
  @Component({
    selector: 'app-shows-released-select',
    templateUrl: './shows-released-select.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
  })
  export class ShowsReleasedSelectComponent implements OnChanges {
    typeSelect: string = 'Situação: '
    @Input() active?: boolean;
    @Input() type = ''
    @Output() activeChange = new EventEmitter<boolean | undefined>();
  
    selected?: SelectItem<boolean | undefined>;
    status: SelectItem<boolean | undefined>[] = [
        {
            label: 'Todos',
            value: undefined
        },
        {
          label: 'Não lançados',
          value: false
        },
        {
          label: 'Lançados',
          value: true
        }
    ]
  
    constructor() {}
  
    ngOnChanges(changes: SimpleChanges): void {
      if (changes.active) {
        this.selected = this.status?.find(
          (select) => select.value === this.active
        );
      }
    }
  
    change(selectedItem: SelectItem<boolean | undefined>): void {
      this.active = selectedItem.value;
      this.selected = selectedItem;
      this.activeChange.emit(this.active);
    }
  }
  